import { CheckoutSettings } from "./../../../../core/models/model";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  AfterViewInit,
} from "@angular/core";
import { PaymentDetails } from "../../models/paymentdetails";
import { Router } from "@angular/router";
import { StorageService } from "src/app/core/helpers/storage-Service";
import { PaymentMethodInfo } from "src/app/core/models/model";

enum PaymentMethods {
  CARD = "Card",
  MOMO = "MOMO",
  BANK = "Bank",
  USSD = "USSD",
  MGPS = "MGPS",
  QR = "qr",
  OPAY = "OPAY",
  MONO = "MONO",
}

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  standalone: false,
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() currentActiveHeader;
  @Input() paymentDetails: PaymentDetails;
  //the channel actually on screen. driven by the parent so a failed switch
  //never leaves the highlight on a channel that was not opened
  @Input() activeMethod: string;
  @Output() paymentMethod = new EventEmitter<string>();

  readonly PaymentMethods = PaymentMethods;
  selectedPaymentMethod: string = "";

  isBankDisabled: boolean = false;
  isCardDisabled: boolean = false;
  isUSSDDisabled: boolean = false;
  isMOMOdisabled: boolean = false;
  isMPGSDisabled: boolean = false;
  isQRDisabled: boolean = false;

  paymentOptions: any[] = [];

  // logo = "https://www.globalaccelerex.com/images/Global-Accelerex-logo.png";

  paymentInfo: Partial<CheckoutSettings>;
  selectedMethod: string;

  constructor(
    private router: Router,
    private storage: StorageService,
  ) {}

  getPaymentIcon(method: string): string {
    switch (method) {
      case "CARD":
        return "assets/rexpay/card_icon.png";
      case "USSD":
        return "assets/rexpay/ussd_icon.png";
      case "BANK":
        return "assets/rexpay/transfer_icon.png";

      case "ACCOUNT TRANSFER":
        return "assets/rexpay/bank_icon.png";
      case "OPAY":
        return "assets/rexpay/opay-img.png";

      // case "MOMO":
      //   return "assets/rexpay/card.svg";
      default:
        return "assets/rexpay/default.png";
    }
  }

  ngOnInit() {
    this.paymentInfo = this.storage.getPaymentInfo();

    if (JSON.stringify(this.paymentInfo) === "{}" || !this.paymentInfo) {
      this.paymentInfo = {};

      this.paymentInfo.paymentMethodInfo = {
        accountTransferEnabled: true,
        cardEnabled: true,
        // internetBankingEnabled: true,
        ussdEnabled: true,
        // qrCodeEnabled: true,
        bankAppEnabled: true,
      };
    }

    const paymentInfo = this.paymentInfo?.paymentMethodInfo;

    // build available payment methods
    const availableMethods = [];

    if (paymentInfo?.cardEnabled) availableMethods.push("CARD");
    if (paymentInfo?.ussdEnabled) availableMethods.push("USSD");
    if (paymentInfo?.bankAppEnabled) availableMethods.push("BANK");

    if (paymentInfo?.accountTransferEnabled)
      availableMethods.push("ACCOUNT TRANSFER");
    if (paymentInfo?.bankAppEnabled) availableMethods.push("OPAY");
    // if (paymentInfo?.internetBankingEnabled)
    //   availableMethods.push("INTERNET_BANKING");
    // if (paymentInfo?.qrCodeEnabled) availableMethods.push("QR");

    // put defaultChannel first

    const defaultChannel = paymentInfo?.defaultChannel;
    // this.selectedPaymentMethod = defaultChannel;

    this.paymentOptions = availableMethods.sort((a, b) => {
      if (a === defaultChannel) return -1;
      if (b === defaultChannel) return 1;
      return 0;
    });

    this.selectedMethod = this.paymentOptions[0];
    this.selectedPaymentMethod = this.paymentOptions[0];

    this.checkUrl();
  }

  checkUrl() {
    if (
      !this.paymentInfo.paymentMethodInfo.cardEnabled &&
      !this.paymentInfo.paymentMethodInfo.ussdEnabled
    ) {
      this.selectedPaymentMethod = "BANK";
    } else if (
      this.paymentInfo.paymentMethodInfo.ussdEnabled &&
      !this.paymentInfo.paymentMethodInfo.cardEnabled
    ) {
      this.selectedPaymentMethod = "USSD";
    } else {
      this.selectedPaymentMethod = "CARD";
    }

    this.paymentMethod.emit(this.selectedMethod);
  }

  ngOnChanges() {
    this.disableOtherPaymentOptions(this.currentActiveHeader);
  }

  disableOtherPaymentOptions(option) {
    if (option == "ussd") {
      this.isBankDisabled = true;
      this.isCardDisabled = true;
      this.isMOMOdisabled = true;
      this.isMPGSDisabled = true;
      this.isQRDisabled = true;
      this.isUSSDDisabled = false;
      return;
    }
    if (option == "bank") {
      this.isBankDisabled = false;
      this.isCardDisabled = true;
      this.isUSSDDisabled = true;
      this.isMPGSDisabled = true;
      this.isMOMOdisabled = true;
      this.isQRDisabled = true;
      return;
    }
    if (option == "momo") {
      this.isBankDisabled = true;
      this.isCardDisabled = true;
      this.isUSSDDisabled = true;
      this.isMPGSDisabled = true;
      this.isQRDisabled = true;
      this.isMOMOdisabled = false;
      return;
    }
    if (option == "mpgs") {
      this.isBankDisabled = true;
      this.isCardDisabled = true;
      this.isUSSDDisabled = true;
      this.isMPGSDisabled = false;
      this.isMOMOdisabled = true;
      this.isQRDisabled = true;
      return;
    }
    if (option == "card") {
      this.isBankDisabled = true;
      this.isCardDisabled = false;
      this.isUSSDDisabled = true;
      this.isMOMOdisabled = true;
      this.isMPGSDisabled = true;
      this.isQRDisabled = true;
      return;
    }
    if (option == "qr") {
      this.isBankDisabled = true;
      this.isCardDisabled = true;
      this.isUSSDDisabled = true;
      this.isMOMOdisabled = true;
      this.isMPGSDisabled = true;
      this.isQRDisabled = false;
      return;
    } else {
      this.isBankDisabled = false;
      this.isCardDisabled = false;
      this.isUSSDDisabled = false;
      this.isMOMOdisabled = false;
      this.isMPGSDisabled = false;
      this.isQRDisabled = false;
    }
  }

  switchPaymentMethod(method: string) {
    this.paymentMethod.emit(method);
  }
}
